import * as React from 'react';

import { Grid, Typography, Typography2 } from '@coursera/cds-core';

type Props = {
  label: string;
  content: string;
  ['data-testid']?: string;
};

const ContentBlock = ({ label, content, 'data-testid': dataTestId }: Props) => {
  return (
    <Grid container spacing={16} data-testid={dataTestId}>
      <Grid item xs={12}>
        <Typography variant="h2semibold" component="h2">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography2 variant="bodyPrimary" component="p">
          {content}
        </Typography2>
      </Grid>
    </Grid>
  );
};

export default ContentBlock;
